import Esearcher from './Esearcher/index.js';

$(function () {
    const stackTopRight = new Esearcher.pNotify.Stack({
        dir1: 'down',
        dir2: 'left',
        firstpos1: 25,
        firstpos2: 25,
        push: 'top',
        modal: false,
        maxOpen: Infinity
    });

    function bindDeactiveReminderEvent() {
        $(document).off('click', '[name=deactivate]');
        $(document).on('click', '[name=deactivate]', function (e) {
            var id = $(e.target).attr('data-id');
            $.ajax({
                url: '/reminder/disable/' + id,
                method: 'POST',
            }).done(function () {
                for (var i = 0; i < stackTopRight.length; i++) {
                    if (stackTopRight.notices[i].$$.ctx[
                        stackTopRight.notices[i].$$.props.addClass
                        ] === "reminder_" + id) {
                        stackTopRight.notices[i].close();
                    }
                }
                Esearcher.Connect.getInstance().runPolling('reminderService-getCurrentReminders');
            });
        });
    }

    function bindDelay60ReminderEvent() {
        $(document).off('click', '[name=delay60]');
        $(document).on('click', '[name=delay60]', function (e) {
            var id = $(e.target).attr('data-id');
            $.ajax({
                url: '/reminder/delay/60/' + id,
                method: 'POST'
            }).done(function () {
                for (var i = 0; i < stackTopRight.length; i++) {
                    if (stackTopRight.notices[i].$$.ctx[
                        stackTopRight.notices[i].$$.props.addClass
                        ] === "reminder_" + id) {
                        stackTopRight.notices[i].close();
                    }
                }
                Esearcher.Connect.getInstance().runPolling('reminderService-getCurrentReminders');
            });
        });
    }

    function bindSelectDelayEvent() {
        $(document).on('click', '[name=selectDelay]', function (e) {
            var parentDiv = $(this).parents('div.ui-pnotify');
            $(document).find('div.ui-pnotify').css('z-index', 100040);
            parentDiv.css('z-index', 110040);

        });

        $(document).off('click', '[name=delay]');
        $(document).on('click', '[name=delay]', function (e) {
            var target = e;
            var delay = $(e.target).attr('data-id');
            var id = $(e.target).attr('id');
            $.ajax({
                url: '/reminder/delay/' + delay + '/' + id,
                method: 'POST'
            }).done(function () {
                for (var i = 0; i < stackTopRight.length; i++) {
                    if (stackTopRight.notices[i].$$.ctx[
                        stackTopRight.notices[i].$$.props.addClass
                        ] === "reminder_" + id) {
                        stackTopRight.notices[i].close();
                    }
                }
                localStorage.removeItem("last-po-request-at");
                localStorage.removeItem("po-data-loaded-at");
            });
        });
    }

    var isInIframe = (window.location != window.parent.location) ? true : false;
    if (isInIframe) {
        return;
    }

    function getCookie(name) {
        const cookie = document.cookie.split('; ').find(row => row.startsWith( name + '='));

        if (cookie) {
            return decodeURIComponent(cookie.split('=')[1]);
        }

        return null;
    }

    if (getCookie('__messages') !== undefined) {
        const e = JSON.parse(getCookie('__messages'));
        document.cookie = '__messages=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        const notifier = Esearcher.Ui.Notifier.getInstance();
        $.each(e, function (part, data) {
            $.each(data, function (a, text) {
                notifier.notify(text.replace(/&nbsp;/g, ' '), part);
            });
        });
    }
    let polling = new Esearcher.Polling(
        'reminderService-getCurrentReminders',
        60000,
        function (data) {
            for (var index = 0; index < data.length; ++index) {
                if (!($('#reminder_' + data[index].id).length)) {
                    Esearcher.pNotify.notice({
                        addClass: 'reminder_' + data[index].id,
                        title: data[index].title,
                        text: data[index].html,
                        textTrusted: true,
                        titleTrusted: true,
                        icon: false,
                        styling: 'esearcher',
                        hide: false,
                        closer: false,
                        sticker: false,
                        stack: stackTopRight
                    });
                }
            }
            bindDeactiveReminderEvent();
            bindDelay60ReminderEvent();
            bindSelectDelayEvent();
        },
        true
    );
    let observer = new MutationObserver(function (mutations, me) {
        let body = document.body;
        if (body) {
            Esearcher.Connect.getInstance().poll(polling);
            me.disconnect(); // stop observing
            return;
        }
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });

});